export default __webpack_public_path__ + "static/media/Barbs of the Blood Drinker.a56dc2b0.jpg";